import store from '@/store'

export function hasPermission(to) {
  
  if (to?.meta?.requiresPermission) {
    
    // check main-route directly
    if (!Array.isArray(to?.meta?.requiresPermission)) {
      return store.getters.hasPermission(to?.meta?.requiresPermission)
    }
    
    // find requiredPermission from meta based on tabName
    let reqPermission = to?.meta?.requiresPermission?.find(
      e => e.routeName === to.params.tabName
    )
    
    // check child-routes based on paramName
    return !(reqPermission !== undefined &&
      to.params[reqPermission.paramName] === reqPermission.routeName &&
      !store.getters.hasPermission(reqPermission.permission))
  } else {
    // no need for permission-check
    // access granted
    return true
  }
}
